import React from "react";

interface HeroTextProps {
  text: string;
}

export const HeroText: React.FC<HeroTextProps> = ({ text }) => (
  <div className="hero">
    <div className="container">
      <p className="hero-text">{text}</p>
    </div>
  </div>
);
